import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import { Button, Popover, Checkbox, ActionList } from "@shopify/polaris";
import { useState } from "react";

RHFMultiSelect.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function RHFMultiSelect({ name, options, label, disabled = false }) {
  const { control } = useFormContext();
  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopoverActive = () => setPopoverActive((prev) => !prev);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <Popover
            active={popoverActive}
            activator={
              <Button onClick={togglePopoverActive} disclosure disabled={disabled} fullWidth>
                {label ? `${label}: ` : ""} {field.value?.length ? `${field.value.length} selected` : "None selected"}
              </Button>
            }
            onClose={togglePopoverActive}
          >
            <ActionList
              items={options.map((option) => ({
                content: (
                  <Checkbox
                    label={option.label}
                    checked={field.value?.includes(option.value) || false}
                    onChange={(checked) => {
                      const newValue = checked
                        ? [...(field.value || []), option.value]
                        : field.value.filter((value) => value !== option.value);
                      field.onChange(newValue);
                    }}
                    disabled={disabled}
                  />
                ),
              }))}
            />
          </Popover>
          {error && <div style={{ color: "red", marginTop: "4px" }}>{error.message}</div>}
        </div>
      )}
    />
  );
}
